import React from 'react'
import clsx from 'clsx'
import { Helmet } from 'react-helmet'
import { makeStyles, styled } from '@material-ui/core/styles'
import { useLocation } from '@reach/router'
import useSiteMetadata from './SiteMetadata'

import Footer from './Footer'
import Navbar from './Navbar'

export const HeaderSpacing = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(9),
  [theme.breakpoints.down('xs')]: {
    paddingBottom: theme.spacing(7),
  },
  [`${theme.breakpoints.down('xs')} and (orientation: portrait)`]: {
    paddingBottom: theme.spacing(8),
  },
}))

/*
const PageContainer = styled(({ background, ...other }) => <div {...other} />)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background: (props) => {
      return '#000'
    },
  }),
)
*/

const PageContainer = styled('div')(({ theme, background }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: background && theme.palette.background[background],
}))

const useStyles = makeStyles({
  contentContainer: {
    flex: '1 0 auto',
  },
  smallMaxWidth: {
    maxWidth: 1152,
    margin: 'auto',
  },
})

const Layout = ({
  children,
  title,
  description,
  background,
  noMenu,
  logoLink,
  smallMaxWidth,
  ogImage,
}) => {
  const siteMetaData = useSiteMetadata()
  const { pathname } = useLocation()
  const classes = useStyles()

  title = title ? `${title} - ${siteMetaData.name}` : siteMetaData.title
  description = description ? description : siteMetaData.description
  ogImage = ogImage ?? `${siteMetaData.siteUrl}${siteMetaData.image}`

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:image" content={ogImage} />
        <meta
          property="og:url"
          content={`${siteMetaData.siteUrl}${pathname}`}
        />
      </Helmet>
      <Navbar showMenu={!noMenu} logoLink={logoLink} />
      <PageContainer background={background}>
        <HeaderSpacing />
        <div
          className={clsx(
            classes.contentContainer,
            smallMaxWidth && classes.smallMaxWidth,
          )}
        >
          {children}
        </div>
        {__BUILDFOR__ === ' ' && <Footer />}
      </PageContainer>
    </>
  )
}

Layout.defaultProps = {
  logoLink: 'home',
}

export default Layout
